const {
    endsWith,
} = require('lodash');

class ProductRecommendationService {
    constructor(restangularV3, $window, settings, breakpointsService) {
        this._daasApi = restangularV3.one('ProductRecommendation');
        this.$window = $window;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.daasSourceName = 'DAAS';
    }


    createStrategyPlacement(index, products, strategy) {
        return {
            message: strategy.title,
            strategy: strategy.code,
            placement_name: strategy.placement_type,
            items: products.map(this.createProductPlacement),
        };
    }

    createProductPlacement(product) {
        return {
            id: product.id,
        };
    }

    lookupStrategyForPlacements(strategies, placement) {
        return strategies.find(x => x.id === placement.strategy_id);
    }


    preparePlacements(data) {
        return data.placements.map((placement, i) =>
            this.createStrategyPlacement(i, placement.items, this.lookupStrategyForPlacements(data.strategies, placement)));
    }

    getEffectivePlacementId(placementId) {
        return this.breakpointsService.isInSmallFormat && !endsWith(placementId, '_mobile') ? `${placementId}_mobile` : placementId;
    }

    fetchAndBindDaasData() {
        let productId = '0';
        if (this.$window.R3_ITEM) {
            productId = this.$window.R3_ITEM.id;
        }

        this._daasApi.one(productId).get().then((json) => {
            const daasPlacements = this.preparePlacements(json);
            daasPlacements.forEach((placement, index) => {
                placement.placement_name = this.getEffectivePlacementId(placement.placement_name);
                this.$window.RR.data.JSON.placements[index] = placement;
            });

            this.$window.RR.data.JSON.placements.productSource = this.daasSourceName;
            if (this.$window.RR.jsonCallback) {
                this.$window.RR.jsonCallback();
            }
        });
    }

    shouldBindDaasDataToPage() {
        if (
            // product details
            (location.pathname.startsWith('/shop/productdetails') && this.settings.productDetailsAdditionalAttributes.enableDaasProductDetails) ||
            // quick reorder
            (location.pathname.startsWith('/shop/mylists/reorder') && this.settings.quickReorder.enableDaasQuickReorder)
        ) {
            return true;
        }
        return false;
    }
}

module.exports = ProductRecommendationService;



// WEBPACK FOOTER //
// ./src/shop/productrecommendation/productrecommendation.service.js